import styled from './verificacao.module.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../services/global';
import api from '../../services/api';
import {Alerta} from '../../utils/functions';


function Verificacao() {
    const [wcod1, setCod1] = useState('');
    const [wcod2, setCod2] = useState('');
    const [wcod3, setCod3] = useState('');
    const [wcod4, setCod4] = useState('');
    const [wcod5, setCod5] = useState('');
    const [wcod6, setCod6] = useState('');
    const { status, setStatus,cgcglobal } = useContext(AuthContext);
    const Navigate = useNavigate();


    function handleInput(wfield,wcod){
        if(wfield==1){
            setCod1(wcod);
        }
        if(wfield==2){
            setCod2(wcod);
        }
        if(wfield==3){
            setCod3(wcod);
        }
        if(wfield==4){
            setCod4(wcod);
        }
        if(wfield==5){
            setCod5(wcod);
        }
        
        const nextfield = document.querySelector('#field'+(wfield+1));
        if (nextfield !== null){
            nextfield.focus();
        }
        
    }


    //Funcão Verifica Código Se é valido*************************************
    async function ValidaCod() {
        let wcodace = wcod1 + wcod2 + wcod3 + wcod4 + wcod5 + wcod6;
        await api.get(`verifica/?cgccli=${cgcglobal}&codace=${wcodace}`)
            .then((response) => {
                if (!response.data.msg) {
                    setStatus('criarsenha');
                    Navigate('/Criarsenha');
                } else {
                    setCod1('');
                    setCod2('');
                    setCod3('');
                    setCod4('');
                    setCod5('');
                    setCod6('');
                    Alerta('Erro',response.data.msg,'error')
                }
            })
    }
    //**********************************************************************

    useEffect(() => {
        setCod1('');
        setCod2('');
        setCod3('');
        setCod4('');
        setCod5('');
        setCod6('');
    }, [status])



    return (
        <div className={styled.page}>
            <div className={styled.container}>
                <div className={styled.logo}>
                    <div className={styled.logoimg}></div>
                </div>
                <div className={styled.card}>
                    <div className={styled.cardheader}>
                        <div className={styled.cardtitle}>
                            <a className={styled.cardtitletext}>Código de verificação</a>
                            <div className={styled.cardtitleline}></div>
                        </div>
                    </div>
                    <div className={styled.cardcontent}>
                        <div className={styled.appprimeiroacesso}>
                            <a className={styled.textcontent}>Foi enviado um e-mail para o endereço informado contendo um código de verificação.
                                Informe o código nos campos abaixo:</a>
                            <div className={styled.frame100}>
                                <input id="field1" type="number" className={styled.field} value={wcod1} onChange={(e) => e.target.value.length <= 1 ? handleInput(1,e.target.value) : null} />
                                <input id="field2" type="number" className={styled.field} value={wcod2} onChange={(e) => e.target.value.length <= 1 ? handleInput(2,e.target.value) : null} />
                                <input id="field3" type="number" className={styled.field} value={wcod3} onChange={(e) => e.target.value.length <= 1 ? handleInput(3,e.target.value) : null} />
                                <input id="field4" type="number" className={styled.field} value={wcod4} onChange={(e) => e.target.value.length <= 1 ? handleInput(4,e.target.value) : null} />
                                <input id="field5" type="number" className={styled.field} value={wcod5} onChange={(e) => e.target.value.length <= 1 ? handleInput(5,e.target.value) : null} />
                                <input id="field6" type="number" className={styled.field} value={wcod6} onChange={(e) => e.target.value.length <= 1 ? setCod6(e.target.value) : null}
                                    onBlur={() => ValidaCod()} />


                            </div>

                            {/*<button className={styled.button}>REENVIAR CÓDIGO</button>*/}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )

}


export default Verificacao;